/* eslint-disable consistent-return */
import { styled } from '@material-ui/core';
import { useEffect, useMemo, useRef } from 'react';
import { getWidgetStore } from './WidgetStore';

type WidgetContainerProps = {
  widgetName: string;
  source: string;
  devMode: boolean;
};

const WIDGET_DEV_HOST = 'https://localhost:3010/';

const WidgetIFrame = styled('iframe')({
  display: 'flex',
  flex: 1,
  border: 0,
});

const WidgetContainer: React.FC<WidgetContainerProps> = ({
  devMode,
  widgetName,
  source,
}) => {
  const url = useMemo(() => {
    try {
      const urlObj = new URL(devMode ? `${WIDGET_DEV_HOST}` : source);

      urlObj.searchParams.append('parent-origin', window.location.origin);

      return urlObj.toString();
    } catch {
      return '';
    }
  }, [source, devMode]);

  const ref = useRef<HTMLIFrameElement>(null);

  const store = getWidgetStore();

  useEffect(() => {
    const { current: iframe } = ref;

    if (!iframe?.contentWindow) return;

    const { origin } = new URL(iframe.src);
    const iframePort = iframe.contentWindow;

    store.port.addMessagePort(iframePort, origin);

    return () => {
      store.port.removeMessagePort(iframePort);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <WidgetIFrame ref={ref} src={url} name={widgetName} />;
};

export default WidgetContainer;
